import styled from "styled-components/macro";
import { HoursAndMinutes } from "./subcomponents/HoursAndMinutes";
import { useFlightTranslation } from "utils/customHooks/useFlightTranslation";

export function PnlBreakdownTotalTimeIndicator({
  totalTime,
}: {
  totalTime: number;
}) {
  const { t } = useFlightTranslation();
  return (
    <IndicatorStyles $t={t}>
      <HoursAndMinutes {...{ timeMs: totalTime }} />
    </IndicatorStyles>
  );
}
const IndicatorStyles = styled.div`
  z-index: 1;
  position: absolute;
  top: -1.5em;
  z-index: 1;
  width: 0;
  display: flex;
  justify-content: end;
  .hoursMinutes {
    opacity: 0.5;
    display: flex;
    .minutes {
      min-width: 4.3ch;
      text-align: right;
    }
  }
`;
